// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"11f28b5f","284":"2d3a00ce","467":"07ebf141"}[chunkId] + ".chunk.js";
};